<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<div class="modal-content">
  <div class="referral-modal-icon">
    <span  #confettiStarter class="ds-title-1">🎉</span>
  </div>
  <div class="referral-modal-content">
    <h3 class="ds-title-4">{{ 'TRANSACTIONS.referrals.modal.title' | translate }}</h3>
    <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'TRANSACTIONS.referrals.modal.desc' | translate }}</p>
    <div>
      <h2 class="ds-heading-2">{{ 'TRANSACTIONS.referrals.modal.reward' | translate }}</h2>
    </div>
  </div>
  <div class="referral-modal-actions">
    <app-ds-button size="default" variant="primary" (clicked)="onInvited()">
      {{ 'TRANSACTIONS.referrals.modal.actions.invite' | translate }}
    </app-ds-button>
    <span class="ds-ui-2 ds-color-core-neutral-7" (click)="onDismiss()">{{ 'TRANSACTIONS.referrals.modal.actions.close' | translate }}</span>
  </div>
</div>
